import { loadStripe, Stripe } from '@stripe/stripe-js';

/**
 * Stripe Publishable Key Configuration
 *
 * IMPORTANT: You must set the Stripe publishable key in your environment:
 * - Create a .env file in the solution-org-app directory
 * - Add: REACT_APP_STRIPE_PUBLISHABLE_KEY=pk_test_YOUR_KEY_HERE
 *
 * The publishable key (pk_test_xxx or pk_live_xxx) is safe to expose in frontend code.
 * NEVER use the secret key (sk_test_xxx or sk_live_xxx) in frontend code.
 *
 * Get all Keys with Service Nation Team (Client and Server side keys must match)
 */
// Initialize Stripe - this will be used by the Elements provider
let stripePromise: Promise<Stripe | null> | null = null;

export const getStripe = (): Promise<Stripe | null> | null => {
  if (!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY) {
    // eslint-disable-next-line no-console
    console.error(
      'Missing Stripe publishable key. Please set REACT_APP_STRIPE_PUBLISHABLE_KEY in your .env file.',
    );
    return null;
  }

  if (!stripePromise) {
    stripePromise = loadStripe(
      process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    );
  }
  return stripePromise;
};

export const isStripeConfigured = (): boolean => !!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
